import { render, staticRenderFns } from "./WithdrawalRequest.vue?vue&type=template&id=137738b3&scoped=true"
import script from "./WithdrawalRequest.vue?vue&type=script&lang=js"
export * from "./WithdrawalRequest.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalRequest.vue?vue&type=style&index=0&id=137738b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137738b3",
  null
  
)

export default component.exports